import { useEffect } from "react";

import { isPresent } from "neetocist";
import { Delete, Plus } from "neetoicons";
import { Button, Label, Input } from "neetoui";
import { useTranslation } from "react-i18next";

import HelpPopover from "components/HelpPopover";

import { INITIAL_QUERY_PARAM } from "./constants";

import useProductEmbedStore from "../useProductEmbedStore";
import { buildQueryParamsFromInputFields } from "../utils";

const DynamicQueryParams = ({ updateCustomization }) => {
  const { t } = useTranslation();
  const { queryParamsProps, queryParams, setQueryParams } =
    useProductEmbedStore.pick();

  const handleAddQueryParam = () => {
    setQueryParams([...queryParams, INITIAL_QUERY_PARAM]);
  };

  const handleRemoveQueryParam = index => {
    const newQueryParams = queryParams.filter((_, i) => i !== index);
    setQueryParams(newQueryParams);
  };

  const handleInputChange = (index, field, value) => {
    const newQueryParams = queryParams.map((param, i) =>
      i === index ? { ...param, [field]: value } : param
    );
    setQueryParams(newQueryParams);
  };

  useEffect(() => {
    updateCustomization({
      queryParams: buildQueryParamsFromInputFields(queryParams),
    });
  }, [queryParams]);

  return (
    <div>
      <div
        className="mb-2 flex"
        data-testid="dynamic-query-params-label-container"
      >
        <Label data-testid="dynamic-query-params-label">
          {queryParamsProps.label ||
            t("neetoMolecules.productEmbed.queryParam.label")}
        </Label>
        {isPresent(queryParamsProps.helpPopoverProps) && (
          <HelpPopover
            className="ms-1"
            {...queryParamsProps.helpPopoverProps}
          />
        )}
      </div>
      {queryParams.map((param, index) => (
        <div className="mb-2 flex gap-1" key={index}>
          <Input
            data-testid="dynamic-query-key-name-input"
            name={`queryParams.${index}.name`}
            value={param.name}
            placeholder={
              queryParamsProps.keyPlaceholder ||
              t("neetoMolecules.productEmbed.queryParam.keyNamePlaceholder")
            }
            onChange={e => handleInputChange(index, "name", e.target.value)}
          />
          <Input
            data-testid="dynamic-query-key-value-input"
            name={`queryParams.${index}.value`}
            value={param.value}
            placeholder={
              queryParamsProps.valuePlaceholder ||
              t("neetoMolecules.productEmbed.queryParam.keyValuePlaceholder")
            }
            onChange={e => handleInputChange(index, "value", e.target.value)}
          />
          <Button
            data-testid="dynamic-query-delete-button"
            icon={Delete}
            style="text"
            onClick={() => handleRemoveQueryParam(index)}
          />
        </div>
      ))}
      <Button
        className="my-2"
        data-testid="dynamic-query-add-new-button"
        icon={Plus}
        iconPosition="left"
        style="link"
        label={
          queryParamsProps.addButtonLabel ||
          t("neetoMolecules.productEmbed.queryParam.addQueryParam")
        }
        onClick={handleAddQueryParam}
      />
    </div>
  );
};

export default DynamicQueryParams;
